import { getTheme, mergeStyleSets } from '@fluentui/react';

interface ISettingCustomViewClassNames {
    settingCustomViewPageContainer: string;
}

export const useClassNames = (): ISettingCustomViewClassNames => {
    const applicationTheme = getTheme();

    return mergeStyleSets({
        settingCustomViewPageContainer: {
            background: applicationTheme.semanticColors.bodyBackground
        }
    });
}